module.exports = __webpack_public_path__ + "static/media/11NEPAD1.b3621a88.jpg";